





















































export default {
    "name": "DropDownSearch",
    "props": {
        'items': false,
        'showSearchField': false,
        'currentValue': Object,
        'defaultLabel': String,
        'shownKey': String,
        'customClasses': String
    },
    "computed": {
        "itemKey": ()-> 
            if not this.shownKey then return "name" else return this.shownKey
        "filteredItemsList": ()->
            self = @
            if self.itemsList?
                ret = self.itemsList.filter((item)->
                    if !item[self.itemKey]?
                        return false
                    item[self.itemKey].toLowerCase().indexOf(self.filter.toLowerCase()) >= 0)
            else
                []
    },
    "methods": {
        "trigger": (e)->
            if e.target.id == "clear-selected"
                @active = false
            else
                @active = !@active
                if @active && this.showSearchField
                    @$nextTick => @$refs.searchField.focus()

        "clear": (e)->
            @selectedItem = null
            e.preventDefault()
        "click": ()-> 
            this.active = not this.active
        "closeListener": (e)-> 
            vm = @
            if not vm.$el.contains(e.target)
                vm.active = false
            return
    },
    "data": ()-> 
        return {
            filter: "",
            itemsList: [],
            active: false,
            selectedItem: this.currentValue || {}
        }
    "mounted": ()->
        vm = @
        if vm.items?
            vm.itemsList = await vm.items
        document.addEventListener('click', vm.closeListener, true)
    "beforeDestroy": ()->
        vm = @
        document.removeEventListener('click', vm.closeListener, true)
    "watch": {
        "items": (newVal, oldVal)->
            if newVal?
                @itemsList = newVal
        "currentValue": (newVal, oldVal)-> 
            this.selectedItem = newVal
        "selectedItem": (newVal, oldVal) -> 
            this.$emit('dropdownClick', newVal)
    }
}
